(function () {
  const normalize = (value) => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .replace(/[’']/g, '')
    .replace(/[^\p{L}\p{N}%]+/gu, ' ')
    .trim();
  const stopwords = {
    en: new Set(['a', 'an', 'and', 'can', 'do', 'does', 'find', 'how', 'i', 'is', 'me', 'my', 'please', 'the', 'to', 'want', 'was', 'what', 'where', 'with', 'you'] ),
    de: new Set(['eine', 'ein', 'ich', 'ist', 'meine', 'mir', 'möchte', 'mochte', 'und', 'wie', 'was', 'wo', 'zu'] ),
    fr: new Set(['à', 'au', 'comment', 'dans', 'de', 'des', 'est', 'je', 'ma', 'mon', 'où', 'ou', 'pour', 'que', 'une', 'un', 'veut', 'veux'] )
  };
  const aliases = {
    where: ['where', 'tracking', 'track'],
    wo: ['wo', 'tracking', 'track'],
    ou: ['ou', 'tracking', 'track'],
    track: ['track', 'tracking', 'sendungsverfolg', 'suivi'],
    tracking: ['tracking', 'sendungsverfolg', 'suivi'],
    package: ['package', 'parcel', 'order'],
    parcel: ['parcel', 'package', 'order'],
    paket: ['paket', 'bestellung', 'order'],
    colis: ['colis', 'commande', 'order'],
    cancel: ['cancel', 'cancellation', 'stornier', 'stornierung', 'annul'],
    stornieren: ['stornieren', 'stornierung', 'cancel', 'cancellation'],
    annuler: ['annuler', 'annulation', 'cancel', 'cancellation'],
    return: ['return', 'returns', 'zuruck', 'ruckgabe', 'retour'],
    zuruck: ['zuruck', 'ruckgabe', 'return', 'returns'],
    retour: ['retour', 'retourner', 'return', 'returns'],
    retourner: ['retourner', 'retour', 'return', 'returns'],
    sende: ['sende', 'send', 'return', 'returns'],
    declined: ['declined', 'decline', 'failed', 'failure'],
    abgelehnt: ['abgelehnt', 'fehlgeschlagen', 'declined', 'failed'],
    refuse: ['refuse', 'refusé', 'declined', 'failed']
  };

  class FormulaSwissHelpTopics {
    constructor(root) {
      this.root = root;
      this.searchWrap = root.querySelector('[data-fs-faq-search-wrap]');
      this.form = root.querySelector('[data-fs-faq-search-form]');
      this.search = root.querySelector('[data-fs-faq-search]');
      this.clear = root.querySelector('[data-fs-faq-clear]');
      this.status = root.querySelector('[data-fs-faq-status]');
      this.noResults = root.querySelector('[data-fs-faq-no-results]');
      this.items = Array.from(root.querySelectorAll('[data-fs-faq-item]'));
      this.groups = Array.from(root.querySelectorAll('[data-fs-faq-group]'));
      this.previousOpenState = null;
    }

    init() {
      if (!this.search || !this.searchWrap || !this.status) return;
      this.root.dataset.fsFaqEnhanced = 'true';
      if ((document.documentElement.lang || 'en').slice(0, 2).toLowerCase() === 'en') {
        this.items.forEach((item) => { item.open = false; });
      }
      this.search.addEventListener('input', () => this.applyFilter(this.search.value));
      this.clear?.addEventListener('click', () => { this.search.value = ''; this.applyFilter(''); this.search.focus(); });
      this.form?.addEventListener('submit', (event) => event.preventDefault());
      this.root.addEventListener('click', (event) => {
        const anchor = event.target.closest('a[href^="#"]');
        const copy = event.target.closest('[data-fs-faq-copy]');
        if (copy && this.root.contains(copy)) { event.preventDefault(); this.copyLink(copy); return; }
        if (anchor && this.root.contains(anchor)) {
          let id;
          try { id = decodeURIComponent(anchor.getAttribute('href').slice(1)); } catch (error) { return; }
          if (this.revealHash(id)) {
            event.preventDefault();
            if (window.location.hash.slice(1) !== id) window.history.pushState({}, '', `#${id}`);
          }
        }
      });
      window.addEventListener('hashchange', () => this.revealHash(window.location.hash.slice(1)));
      this.items.forEach((item) => this.prepareCopy(item));
      this.updateStatus(this.items.length);
      if (window.location.hash) this.revealHash(window.location.hash.slice(1));
      this.searchWrap.hidden = false;
    }

    searchableText(item) {
      const summary = item.querySelector('summary')?.textContent || '';
      const answerNodes = Array.from(item.querySelectorAll('[data-fs-faq-answer] p, .fs-help-answer > p')).filter((node) => !node.closest('.fs-help-handoff'));
      item.querySelectorAll('[data-fs-faq-answer]').forEach((answer) => {
        if (answer.matches('p') && !answerNodes.includes(answer) && !answer.closest('.fs-help-handoff')) answerNodes.push(answer);
      });
      if (!answerNodes.length) {
        const firstParagraph = Array.from(item.querySelectorAll('.fs-help-answer p')).find((node) => !node.closest('.fs-help-handoff'));
        if (firstParagraph) answerNodes.push(firstParagraph);
      }
      const answer = answerNodes.map((p) => p.textContent).join(' ');
      return normalize(`${summary} ${answer} ${item.getAttribute('data-fs-faq-keywords') || ''}`);
    }

    queryTerms(value) {
      const language = (document.documentElement.lang || 'en').slice(0, 2).toLocaleLowerCase();
      const record = { stopwords: stopwords[language] || stopwords.en, aliases };
      const localAliases = record.aliases;
      const words = normalize(value).split(/\s+/).filter(Boolean);
      const filtered = words.filter((word) => !record.stopwords.has(word));
      const hasReturnIntent = filtered.some((word) => localAliases[word]?.includes('return') || localAliases[word]?.includes('returns') || word === 'return' || word === 'retour' || word === 'retourneren');
      const trackingWords = ['track', 'tracking', 'sendungsverfolg', 'suivi', 'volgen', 'volg'];
      const locationWords = ['where', 'wo', 'ou', 'waar', 'où', 'destination', 'bestemming'];
      const orderWords = ['order', 'bestellung', 'bestellungen', 'commande', 'commander', 'bestelling'];
      const hasTrackingContext = words.some((word) => trackingWords.includes(word)) || (words.some((word) => locationWords.includes(word)) && words.some((word) => orderWords.includes(word)));
      let terms = hasReturnIntent ? filtered.filter((word) => !orderWords.includes(word)) : filtered;
      if (hasTrackingContext) {
        terms = terms.filter((word) => !orderWords.includes(word) && !locationWords.includes(word));
        terms.push('tracking');
      }
      return terms.map((word) => localAliases[word] || [word]);
    }

    applyFilter(value) {
      const tokens = this.queryTerms(value.trim());
      if (!tokens.length) {
        this.restoreOpenState();
        this.items.forEach((item) => { item.hidden = false; });
        this.groups.forEach((group) => { group.hidden = false; });
        if (this.noResults) this.noResults.hidden = true;
        if (this.clear) this.clear.hidden = true;
        this.updateStatus(this.items.length);
        return;
      }
      if (!this.previousOpenState) this.previousOpenState = new Map(this.items.map((item) => [item, item.open]));
      let matchCount = 0;
      this.items.forEach((item) => {
        const text = this.searchableText(item);
        const matches = tokens.length > 0 && tokens.every((alternatives) => alternatives.some((token) => text.includes(token)));
        item.hidden = !matches;
        if (matches) { matchCount += 1; item.open = true; }
      });
      this.groups.forEach((group) => { group.hidden = !group.querySelector('[data-fs-faq-item]:not([hidden])'); });
      if (this.noResults) this.noResults.hidden = matchCount !== 0;
      if (this.clear) this.clear.hidden = false;
      this.updateStatus(matchCount);
    }

    restoreOpenState() {
      if (!this.previousOpenState) return;
      this.previousOpenState.forEach((isOpen, item) => { item.open = isOpen; });
      this.previousOpenState = null;
    }

    revealHash(id) {
      if (!id) return false;
      const target = document.getElementById(id);
      if (!target || !this.root.contains(target)) return false;
      if (this.search.value) { this.search.value = ''; this.applyFilter(''); }
      if (target.matches('[data-fs-faq-item]')) target.open = true;
      requestAnimationFrame(() => {
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        target.querySelector('summary')?.focus({ preventScroll: true });
      });
      return true;
    }

    prepareCopy(item) {
      const button = item.querySelector('[data-fs-faq-copy]');
      if (!button) return;
      button.hidden = false;
      const status = document.createElement('span');
      status.className = 'fs-help-copy-status';
      status.setAttribute('data-fs-copy-feedback', '');
      status.setAttribute('role', 'status');
      button.insertAdjacentElement('afterend', status);
    }

    copyLink(button) {
      const item = button.closest('[data-fs-faq-item]');
      if (!item?.id) return;
      const link = new URL(window.location.pathname, window.location.origin);
      const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) link.searchParams.set('preview_theme_id', preview);
      link.hash = item.id;
      const url = link.href;
      const status = item.querySelector('[data-fs-copy-feedback]');
      if (status) status.textContent = '';
      const fallback = () => {
        let input = item.querySelector('.fs-help-copy-fallback');
        if (!input) { input = document.createElement('input'); input.className = 'fs-help-copy-fallback'; input.type = 'url'; input.readOnly = true; input.setAttribute('aria-label', button.dataset.fsFaqCopyLabel); button.insertAdjacentElement('afterend', input); }
        input.value = url; input.hidden = false; input.focus(); input.select();
      };
      const success = () => {
        if (status) status.textContent = button.dataset.fsFaqCopyStatus;
        const input = item.querySelector('.fs-help-copy-fallback');
        if (input) input.hidden = true;
      };
      if (!navigator.clipboard?.writeText) { fallback(); return; }
      navigator.clipboard.writeText(url).then(success).catch(fallback);
    }

    updateStatus(count) { if (this.status) this.status.textContent = (this.status.dataset.template || '').replace('__COUNT__', count); }
  }

  const initHelpTopics = () => document.querySelectorAll('[data-fs-faq]').forEach((root) => { if (!root.__fsHelpTopics) { root.__fsHelpTopics = new FormulaSwissHelpTopics(root); root.__fsHelpTopics.init(); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHelpTopics, { once: true }); else initHelpTopics();
  document.addEventListener('shopify:section:load', initHelpTopics);
})();
